module.exports = __webpack_public_path__ + "static/media/pust-u-tminu-bo-plakat.7b679320.jpg";